import React, { FC, memo, useState } from 'react';
import { Icon, Timeline } from '@ss/mtd-react';
import useGo from '@utils/navigate';
import { datejs } from '@block/utils';
import dayjs from 'dayjs';
import { IGeneralRecord } from '@src/types';
import { array2String, getHighlightType } from '@utils/formatData';
import { JOB_TYPE, POSITION_STATE } from '@src/enums';

const TimelineItem = Timeline.Item;
interface IProps {
  recordInfo: IGeneralRecord;
}

const DeliveryRecordItem: FC<IProps> = ({ recordInfo }) => {
  const { jobName, jobId, jobType, deliverTime, deliverType, applyStatus, workCity, logList, jobShareType } =
    recordInfo || {};
  const [unfold, setUnfold] = useState(true);
  const { go } = useGo();

  return (
    <div className="delivery_record_item">
      <div className="delivery_record_item_t">
        <div className="delivery_record_item_t_l">
          <div className="position_name">
            <div
              className="title hidden-ellipsis cursor_pointer"
              onClick={() => {
                go(
                  '/position/detail',
                  {
                    jobUnionId: jobId,
                    jobShareType: jobShareType || '1',
                    highlightType: getHighlightType(jobType, jobShareType),
                  },
                  {
                    isNeedFormatUrl: true,
                  },
                );
              }}
            >
              {jobName}
            </div>
            {jobType && (
              <div className={`tag ${jobType === JOB_TYPE.SOCIAL ? 'blue' : 'green'}`}>{POSITION_STATE[jobType]}</div>
            )}
          </div>
          <div className="split_line_box">
            {array2String(workCity, 2) && (
              <div className="split_line_box_item">
                <Icon type="location-o" style={{ fontSize: 16 }} />
                <span>工作地：{array2String(workCity, 2)}</span>
              </div>
            )}
            {deliverType && (
              <div className="split_line_box_item">
                <Icon type="file-export" style={{ fontSize: 16 }} />
                <span>投递方式：{deliverType}</span>
              </div>
            )}
            {dayjs(deliverTime).isValid() && (
              <div className="split_line_box_item">
                <Icon type="time-o" style={{ fontSize: 16 }} />
                <span>投递时间：{datejs(deliverTime).format('YYYY/MM/DD HH:mm:ss')}</span>
              </div>
            )}
          </div>
        </div>
        <div className="delivery_record_item_t_r">{applyStatus}</div>
      </div>
      {/* 社招投递进度仅展示最新状态节点，不展示过程节点 */}
      {logList && Array.isArray(logList) && (
        <div className="delivery_record_item_b">
          <div
            className="unfold cursor_pointer"
            onClick={() => {
              setUnfold(!unfold);
            }}
          >
            <span> {unfold ? '展开' : '收起'}</span>
            <Icon type={unfold ? 'triangle-down' : 'triangle-up'} style={{ fontSize: 24, color: '#a9afb8' }} />
          </div>
          <div className="log_content" style={{ display: unfold ? 'none' : 'block' }}>
            <Timeline className="base-demo">
              {logList.map((item, index) => (
                <TimelineItem
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  title={
                    <div>
                      <span className="title">{item?.title}</span>
                      {dayjs(item?.time).isValid() && (
                        <span className="time">{datejs(item?.time).format('YYYY/MM/DD HH:mm:ss')}</span>
                      )}
                    </div>
                  }
                  // eslint-disable-next-line react/no-danger
                  content={(<div dangerouslySetInnerHTML={{ __html: item?.content }} />) as any}
                />
              ))}
            </Timeline>
          </div>
        </div>
      )}
    </div>
  );
};

export default memo(DeliveryRecordItem);
